module.exports = __webpack_public_path__ + "static/media/Google Pay.957fc001.svg";